import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { CommunicationSubject } from "@/app/services/generated/communicationsubjectService";
import { communicationSubjectService } from "@/app/services/generated/communicationsubjectService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

// Singleton cache store
const communicationSubjectsCacheStore =
  new EntityCacheStore<CommunicationSubject>(
    EnumCacheEntityType.communicationSubject,
    async () => communicationSubjectService.getAllCommunicationSubjects()
  );

// Ephemeral reader
export default class CommunicationSubjectsCache extends EntityWithGuidKeyCache<CommunicationSubject> {
  constructor() {
    super(communicationSubjectsCacheStore, (x) => x.id);
  }
}
